module.exports = {
    onBoarding: {
        bannerImageUrl: 'https://wowdevmediaaae.blob.core.windows.net/content/rewards-header.jpg',
        enableRewardsOnBoarding: false,
        titleLoginContent: '<h2>Start saving with your Rewards card today</h2>',
        textLoginContent: 'You can <a href="/shop/myaccount/woolworthsrewards" style="color:#F47920">join rewards</a> and link your card to start redeeming special offers and products tailored just for you, as you shop.',
        titleSignUpContent: '<h2>Welcome, start saving with your Rewards card today.</h2>',
        textSignUpContent: 'You can <a href="/shop/myaccount/woolworthsrewards" style="color:#F47920">join rewards</a> and begin redeeming special offers and products tailored for you, as you shop in store and online. Or if you\'re already a rewards member you can link your card by clicking on the button below.',

    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/onboarding.js